<div class="header-info">
  <div class="avatar-info">
    <img src="assets/img/ic-edit-form.svg" class="form-avatar" (click)="changeAvatar()">
  </div>
  <div class="profile-info form-name">
    <p class="info-title">{{headerInfo?.title}}</p>
    <h5 id="header-info-name-id"><b>{{headerInfo?.name}}</b></h5>
  </div>
  <div class="status-info">
    <div>
          <span class="badge badge-pill text-uppercase"
                [ngClass]="getStatusCssClass(headerInfo?.statusCode)">
        {{ headerInfo?.statusCode | status }}
          </span>
    </div>
  </div>
</div>
